module.exports = __webpack_public_path__ + "img/Bear24.683f6ebf.jpg";